<template>
  <div class="submit-bar-wrapper">
    <van-submit-bar
      :price="price"
      :loading="loading"
      :disabled="loading"
      button-text="提交订单"
      @submit="handleSubmit"
    />
  </div>
</template>
<script>
export default {
  props: {
    price: [Number],
    loading: [Boolean],
  },
  methods: {
    handleSubmit() {
      this.$emit('submit');
    },
  },
};
</script>
<style lang="less" scoped>
.submit-bar-wrapper {
  bottom: 0;
  z-index: 2;
  position: fixed;
}
</style>
